import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

export const DeletePinDialog = ({
  open,
  onClose,
  onConfirm,
  pinName,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pinName: string;
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>Delete Pin</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the pin "{pinName}"? This action
          cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
